import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-signup-success",
    templateUrl: "./signup-success.component.html",
    styleUrls: ["./signup-success.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class SignupSuccessComponent implements OnInit {
  constructor(private successDialog: MatDialogRef<SignupSuccessComponent>,
    private GTMSegment: GTMSegmentService) {
    this.GTMSegment.GTMPopupInitialization("SignUpSuccessPopup");
  }
  closeME() {
    this.successDialog.close();
  }
  ngOnInit() { }
}
